var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    { attrs: { "no-sidebar": true } },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h1", [_c("small", [_vm._v("Integration System Attributes")])])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-3 margin-bottom-3x" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              ref: "search",
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search by name..." },
              domProps: { value: _vm.searchKey },
              on: {
                keyup: function($event) {
                  if (!$event.type.indexOf("key") && $event.keyCode !== 13) {
                    return null
                  }
                  return _vm.search(_vm.$refs.search.value)
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "input-group-btn" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.search(_vm.$refs.search.value)
                    }
                  }
                },
                [_vm._v("Go!")]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-2 margin-bottom-3x" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.typeFilter,
                  expression: "typeFilter"
                }
              ],
              staticClass: "form-control",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.typeFilter = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "" } }, [_vm._v("All types")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "parking" } }, [
                _vm._v("Parking")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "room" } }, [_vm._v("Room")])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-7 text-right margin-bottom-3x" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-default",
                attrs: { to: { name: "integrationSystems.new" } }
              },
              [
                _c("i", {
                  staticClass: "fa fa-plus",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v("\n        New Integration System\n      ")
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
          ])
        : _c(
            "div",
            [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", { staticClass: "table table-striped" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Name")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Type")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Attributes")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Edit")]),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-right" }, [
                        _vm._v("Remove")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.integrationSystems.data, function(item) {
                        return _c("tr", { key: item.id }, [
                          _c("td", [_vm._v(_vm._s(item.name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.typeLabel(item.type)))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.attributeLabels(item.attributes)))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "integrationSystems.edit",
                                      params: { id: item.id }
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-pencil",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm.removing[item.id]
                              ? _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin fa-fw"
                                  })
                                ])
                              : _c(
                                  "a",
                                  {
                                    staticClass: "text-danger",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.remove(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-times",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      !_vm.integrationSystems.data.length
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-center",
                                attrs: { colspan: "6" }
                              },
                              [_vm._v("No integration systems found.")]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("pagination", {
                attrs: {
                  "pages-number": _vm.integrationSystems.last_page || 1
                },
                on: {
                  pageChanged: function(page) {
                    return _vm.loadPage(page)
                  }
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c("confirm", { ref: "deleteConfirm", attrs: { type: "danger" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30317574", { render: render, staticRenderFns: staticRenderFns })
  }
}